import { formatMoney } from '@betterment/core';
import { Box, Dialog, HStack, Heading, IconButton, Tag, Text, VStack } from '@betterment/samba-react';

import { DirectTradingCashDialog } from './DirectTradingCashDialog';
import { ManageCashButton } from './ManageCashButton';

import { NarrowTypename } from '../../../../graphql/utils/narrow-typename';
import { TransactionOptionsProps } from '../../../../Shared/components/transaction-buttons/TransactionButtons';
import { EnvelopeAccountTransactionOptionsQuery } from '../graphql/envelopeAccountTransactionOptions.generated';

type DirectTradingAccount = NarrowTypename<EnvelopeAccountTransactionOptionsQuery['account'], 'DirectTradingAccount'>;
type Props = TransactionOptionsProps & {
  account: DirectTradingAccount;
};

export const CashBalanceRow: React.FC<Props> = ({ account, transactionOptions, subAccounts }) => {
  const { availableBalance, totalBalance, anyPending } = account.cashBalances;

  return (
    <VStack css={{ gap: 'space.50' }}>
      <HStack css={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <HStack css={{ gap: 'space.50', alignItems: 'center' }}>
          <Box css={{ display: 'flex', alignItems: 'flex-end' }}>
            <Heading variant="title200" css={{ lineHeight: 1 }}>
              Cash balance
            </Heading>
          </Box>

          <Box css={{ display: 'flex', alignItems: 'center' }}>
            <DirectTradingCashDialog
              availableBalance={availableBalance}
              totalBalance={totalBalance}
              anyPending={anyPending}
            >
              <Dialog.Trigger asChild={true}>
                <IconButton name="InfoCircle" label="account balance details" spacing="none" variant="ghostSecondary" />
              </Dialog.Trigger>
            </DirectTradingCashDialog>
          </Box>
        </HStack>
        <Box css={{ display: 'flex', alignItems: 'flex-end' }}>
          <Text variant="text100" css={{ lineHeight: 1 }}>
            {formatMoney(totalBalance)}
          </Text>
        </Box>
      </HStack>
      <HStack css={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>{anyPending ? <Tag accent="grey">Transaction pending</Tag> : null}</Box>
        <ManageCashButton account={account} transactionOptions={transactionOptions} subAccounts={subAccounts} />
      </HStack>
    </VStack>
  );
};
